module.exports = __webpack_public_path__ + "static/media/ppgstressflow1.c1c06cd3.jpg";